import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import userProfileVuex from "@/store/userprofile";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage
});

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    userProfileVuex: userProfileVuex //vuex modules
  }
});
